import styled from '@emotion/styled';
import { CircularProgress } from '@material-ui/core';
import { FC } from 'react';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Length = string | number;

interface Props {
  width?: Length;
  height?: Length;
  size?: Length;
  color?: 'primary' | 'secondary' | 'inherit';
  className?: string;
}

const Spinner: FC<Props> = ({ width = '100%', height = '80px', size = 32, color, className }) => (
  <Root
    className={className}
    style={{
      width: width,
      height: height,
    }}
  >
    <div>
      <CircularProgress size={size} color={color} />
    </div>
  </Root>
);

const Root = styled('div')(
  flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  {
    lineHeight: 0,
  },
);

export default Spinner;
